/*To-do List
Principal Tasks
1. Structure website navigation. /
2. Finish servicios tecnicos section. /
3. Create introduction section. /
4. Create nuestros proyectos section. /
5. Create contact form.
6. Create footer.
7. Add chatbot.
8. Add response for each header contact icon.
9. Add whatsapp contact, apart from the chatbot.
10. Add slided into hidden cover. /

Bug Report
1. Change the Servicios Tecnicos dropdown to expand and be
more repsonsive.
2. Add header change color on scroll.
*/

import {Route, Routes, Outlet, Link} from 'react-router-dom';
import Home from './Pages/Home/Home';
import Contacto from './Pages/Contacto/Contacto';
import Header from './Containers/Header/Header';
import LINKS from './URLS';
import {PAGES, SERVICES} from './URLS';

const App = () => {
  return (
    <>
      <Routes>
        <Route element={<><Header links={LINKS}/><Outlet/></>}
               path={"*"}>
          <Route element={<Home services={SERVICES}/>} path={PAGES.INICIO}/>
          <Route element={<Contacto/>} path={PAGES.CONTACTO}/>
          <Route element={<Home services={SERVICES}/>} path={"*"}/>
        </Route>
      </Routes>
    </>
  );
}

export default App;
